var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { top: "", disabled: _vm.disabledTooltip },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        icon: "",
                        loading: _vm.computedLoading,
                        color: _vm.computedStatus.color,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("click", $event)
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "loader",
                            fn: function () {
                              return [
                                _c(
                                  "v-progress-circular",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          rotate: "-90",
                                          size: "24",
                                          value: _vm.progress,
                                          indeterminate: !_vm.progress,
                                        },
                                      },
                                      "v-progress-circular",
                                      attrs,
                                      false
                                    ),
                                    on
                                  )
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c("v-icon", { attrs: { color: _vm.computedStatus.color } }, [
                    _vm._v(_vm._s(_vm.computedStatus.icon)),
                  ]),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [_c("span", [_vm._v(_vm._s(_vm.computedTooltip))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }